import { useSelector, useDispatch } from 'react-redux';
import { getCurrentPage, getTotalRows, getPageLength } from '../state/gridSelectors';
import {
    goToPage,
    nextPage,
    previousPage,
    firstPage,
    lastPage,
    changePageLength
} from '../state/gridActions';
import { useGridContext } from './gridContext';

const PaginationConsumer = ({ children }) => {
	const gridName = useGridContext();
	const dispatch = useDispatch();
	const currentPage = useSelector(state => getCurrentPage(state, gridName) ?? 0);
	const totalRows = useSelector(state => getTotalRows(state, gridName) ?? 0);
	const pageLength = useSelector(state => getPageLength(state, gridName) ?? 10);
	const props = {
		currentPage,
		totalRows,
		pageLength,
		changePageLength: newPageLength => dispatch(changePageLength(gridName, newPageLength)),
		goToPage: pageNumber => dispatch(goToPage(gridName, pageNumber)),
		nextPage: () => dispatch(nextPage(gridName)),
		previousPage: () => dispatch(previousPage(gridName)),
		firstPage: () => dispatch(firstPage(gridName)),
		lastPage: () => dispatch(lastPage(gridName))
	};
	return children(props);
};

export default PaginationConsumer;
